import { useState, useEffect, useRef, useMemo } from 'react'
import { todayStr, fmtDate, fmtPrice, totalSys, REFRESH_POOL, CNPJS, LOCATIONS, LOC_KEY, LOC_LABEL, LOC_COLOR } from '../../data/seed.js'
import { useGlobalEvLog, logEvent } from '../../store/eventLog.js'
import { nextNewSku, setGlobalProducts } from '../../store/products.js'
import { incluirProdutoOmie, incluirMovimentoOmie } from '../../lib/omie.js'
import { Field, TInp, INP_STYLE, PrimaryBtn, GhostBtn, ActionBtn } from '../shared/ui.jsx'
import { NewProductModal, Card, DashboardOperacional } from './modals.jsx'
import AuditoriaTab from './AuditoriaTab.jsx'
import PlanilhaModule from './PlanilhaModule.jsx'

function StockModule({user,products,setProducts}){
  const [query,setQuery]=useState("");
  const [activeFilter,setActiveFilter]=useState("all");
  const [showNew,setShowNew]=useState(false);
  const [tab,setTab]=useState("estoque");
  const [page,setPage]=useState(1);
  const PAGE_SIZE=20;
  const inputRef=useRef(null);
  useEffect(()=>{setTimeout(()=>inputRef.current?.focus(),100);},[]);

  // Contadores para os badges dos filtros
  const counts=useMemo(()=>({
    all:products.filter(p=>p.inventario_status!=="arquivado").length,
    zero:products.filter(p=>p.inventario_status!=="arquivado"&&totalSys(p)===0).length,
    low:products.filter(p=>p.inventario_status!=="arquivado"&&(s=>s>0&&s<=3)(totalSys(p))).length,
    divergente:products.filter(p=>p.inventario_status!=="arquivado"&&p.fisico!==totalSys(p)).length,
    sem_preco:products.filter(p=>p.inventario_status!=="arquivado"&&(!p.price||p.price===0)).length,
    nao_contabilizado:products.filter(p=>p.inventario_status==="nao_contabilizado").length,
    arquivado:products.filter(p=>p.inventario_status==="arquivado").length,
  }),[products]);

  const FILTERS=[
    {id:"all",    label:"TODOS",          color:"var(--text3)"},
    {id:"zero",   label:"SEM ESTOQUE",    color:"#ff4757"},
    {id:"low",    label:"ESTOQUE CRÍTICO",color:"#ffa502"},
    {id:"divergente",label:"DIVERGENTES", color:"#f97316"},
    {id:"sem_preco",         label:"SEM PRECO",         color:"#a78bfa"},
    {id:"nao_contabilizado", label:"NAO CONTABILIZADO",  color:"#ffa502"},
    {id:"arquivado",         label:"ARQUIVADOS",         color:"#555"},
  ];

  const filtered=useMemo(()=>{
    let list=activeFilter==="arquivado"
      ?products.filter(p=>p.inventario_status==="arquivado")
      :products.filter(p=>p.inventario_status!=="arquivado");
    // Filtro de estado
    if(activeFilter==="zero")      list=list.filter(p=>totalSys(p)===0);
    else if(activeFilter==="low")  list=list.filter(p=>{const s=totalSys(p);return s>0&&s<=3;});
    else if(activeFilter==="divergente") list=list.filter(p=>p.fisico!==totalSys(p));
    else if(activeFilter==="sem_preco")         list=list.filter(p=>!p.price||p.price===0);
    else if(activeFilter==="nao_contabilizado") list=list.filter(p=>p.inventario_status==="nao_contabilizado");
    // Filtro de texto (por cima do estado)
    if(query.trim()){
      const q=query.trim().toLowerCase();
      list=list.filter(p=>p.sku.toLowerCase().includes(q)||p.name.toLowerCase().includes(q));
    }
    return list;
  },[products,activeFilter,query]);useEffect(()=>{setPage(1);},[activeFilter,query]);

    const addProduct=async np=>{
      setGlobalProducts(prev=>[np,...prev]);
      setQuery(np.sku);setActiveFilter("all");
      logEvent({tipo_evento:"CADASTRO",usuario:user?.name||"operador",entidade:"PRODUTO",id_entidade:np.sku,detalhes:`${np.name} | CROMA:${np.croma||0} ESFERA LOC:${np.esfera||0} | ${np.cnpj||""} | NF:${np.nf_numero||"—"}`});
      if(np.cnpj){
        const r=await incluirProdutoOmie(np,np.cnpj);
        if(r.ok){
          setGlobalProducts(prev=>prev.map(p=>p.sku===np.sku?{...p,ncodprod_omie:r.nCodProd}:p));
          logEvent({tipo_evento:"CADASTRO_OMIE",usuario:"sistema",entidade:"PRODUTO",id_entidade:np.sku,detalhes:`nCodProd: ${r.nCodProd} | ${np.cnpj}`});
        }else{
          logEvent({tipo_evento:"CADASTRO_OMIE_ERRO",usuario:"sistema",entidade:"PRODUTO",id_entidade:np.sku,detalhes:`Erro: ${r.err} | ${np.cnpj}`});
        }
      }
    };
    const addLote=async(novos,entradas)=>{
      if(novos.length>0){
        setGlobalProducts(prev=>{
          const next=[...novos,...prev];
          return next;
        });
        for(const np of novos){
          await Promise.resolve(); // força ciclo do React aplicar state
          logEvent({tipo_evento:"CADASTRO",usuario:user?.name||"operador",entidade:"PRODUTO",id_entidade:np.sku,detalhes:`${np.name} | CROMA:${np.croma||0} ESFERA LOC:${np.esfera||0} | ${np.cnpj||""} | NF:${np.nf_numero||"—"}`});
          if(np.cnpj){
            const r=await incluirProdutoOmie(np,np.cnpj);
            if(r.ok){
              setGlobalProducts(prev=>prev.map(p=>p.sku===np.sku?{...p,ncodprod_omie:r.nCodProd}:p));
              logEvent({tipo_evento:"CADASTRO_OMIE",usuario:"sistema",entidade:"PRODUTO",id_entidade:np.sku,detalhes:`nCodProd: ${r.nCodProd} | ${np.cnpj}`});
            }else{
              logEvent({tipo_evento:"CADASTRO_OMIE_ERRO",usuario:"sistema",entidade:"PRODUTO",id_entidade:np.sku,detalhes:`Erro: ${r.err} | ${np.cnpj}`});
            }
          }
        }
      }
      if(entradas.length>0){
        entradas.forEach(({sku,qty,loc,nf_chave,nf_numero,operator})=>{
          const mv={type:"entrada",location:loc,qty,note:`Entrada via NF ${nf_numero}`,operator,date:todayStr()};
          setGlobalProducts(prev=>prev.map(p=>{
            if(p.sku!==sku)return p;
            const key=LOC_KEY[loc];
            const next={...p,movements:[mv,...p.movements]};
            if(key)next[key]=Math.max(0,(p[key]||0)+qty);
            return next;
          }));
          logEvent({tipo_evento:"ENTRADA",usuario:operator||"operador",entidade:"PRODUTO",id_entidade:sku,detalhes:`Entrada automática via NF ${nf_numero} — ${qty}un em ${loc}`});
        });
      }
    };

    const addMovimento=({sku,...mv})=>{setProducts(prev=>prev.map(p=>{if(p.sku!==sku)return p;const key=LOC_KEY[mv.location];const delta=mv.type==="entrada"?mv.qty:mv.type==="saida"?-mv.qty:0;const updated={...p,movements:[mv,...p.movements]};if(key)updated[key]=Math.max(0,(p[key]||0)+delta);return updated;}));};

  const isFiltering=activeFilter!=="all"||query.trim().length>0;

  const TAB_BTN=(id,label)=>(
    <button onClick={()=>setTab(id)}
      style={{padding:"8px 18px",background:"none",border:"none",
        borderBottom:tab===id?"2px solid #ffa502":"2px solid transparent",
        color:tab===id?"#ffa502":"var(--text4)",fontSize:9,letterSpacing:2,
        cursor:"pointer",fontFamily:"'Courier New',monospace",whiteSpace:"nowrap"}}>
      {label}
    </button>
  );

  return(
    <div style={{flex:1,display:"flex",flexDirection:"column",overflow:"hidden"}}>
      {/* Abas */}
      <div style={{display:"flex",borderBottom:"1px solid var(--border)",background:"var(--bg2)",flexShrink:0,paddingLeft:12}}>
        {TAB_BTN("estoque","▣ ESTOQUE")}
        {user.role==="operator"&&TAB_BTN("auditoria","◎ AUDITORIA")}
        {user.role==="operator"&&TAB_BTN("planilha","↕ PLANILHA")}
      </div>

      {tab==="auditoria"&&user.role==="operator"&&<div style={{flex:1,overflowY:"auto",padding:"24px 20px"}}><AuditoriaTab/></div>}
      {tab==="planilha"&&user.role==="operator"&&<PlanilhaModule user={user} products={products} setProducts={setProducts}/>}
      {tab==="estoque"&&<div style={{overflowY:"auto",flex:1,padding:"28px 20px"}}>
      <div style={{maxWidth:860,margin:"0 auto"}}>

        {/* Barra de busca */}
        <div style={{display:"flex",border:"1px solid var(--border2)",borderRadius:2,overflow:"hidden",marginBottom:14}}>
          <input ref={inputRef} style={{flex:1,background:"var(--bg2)",border:"none",outline:"none",color:"var(--text)",padding:"14px 14px",fontSize:12,minWidth:0,fontFamily:"'Courier New',monospace"}}
            value={query} onChange={e=>setQuery(e.target.value)}
            placeholder="Buscar por SKU ou nome..."/>
          {query&&<button onClick={()=>setQuery("")}
            style={{background:"none",border:"none",color:"var(--text4)",padding:"0 12px",fontSize:14,cursor:"pointer",flexShrink:0}}>✕</button>}
          {user.role==="operator"&&<button onClick={()=>setShowNew(true)}
            style={{background:"#00d084",border:"none",color:"#000",padding:"14px 18px",fontWeight:700,fontSize:10,letterSpacing:2,cursor:"pointer",flexShrink:0,whiteSpace:"nowrap"}}>+ NOVO</button>}
        </div>

        {/* Filtros por estado */}
        <div style={{display:"flex",gap:6,marginBottom:20,flexWrap:"wrap"}}>
          {FILTERS.map(f=>{
            const active=activeFilter===f.id;
            const cnt=counts[f.id];
            if(!active&&cnt===0&&f.id!=="all")return null;
            return(
              <button key={f.id} onClick={()=>setActiveFilter(f.id)}
                style={{display:"flex",alignItems:"center",gap:6,padding:"6px 12px",background:active?f.id==="all"?"#ffa50220":f.color+"20":"var(--bg2)",border:`1px solid ${active?f.id==="all"?"#ffa50255":f.color+"55":"var(--border2)"}`,color:active?f.id==="all"?"#ffa502":f.color:"var(--text4)",borderRadius:2,fontSize:9,letterSpacing:2,cursor:"pointer",fontFamily:"'Courier New',monospace",fontWeight:active?700:400,transition:"all .15s"}}>
                {f.label}
                <span style={{fontSize:8,padding:"1px 5px",borderRadius:99,background:active?f.color+"30":f.id==="all"?"var(--bg3)":f.color+"18",color:active?f.color:f.id==="all"?"var(--text4)":f.color,fontWeight:700,minWidth:16,textAlign:"center"}}>
                  {cnt}
                </span>
              </button>
            );
          })}
        </div>

        {/* Contador de resultados */}
        <p style={{fontSize:9,letterSpacing:2,color:"var(--text4)",marginBottom:16}}>
          {isFiltering
            ? filtered.length===0
              ? "NENHUM PRODUTO ENCONTRADO."
              : `${filtered.length} DE ${products.length} PRODUTO(S)`
            : `${products.length} PRODUTOS CADASTRADOS`
          }
        </p>

        {/* Lista */}
        <div style={{display:"flex",flexDirection:"column",gap:12}}>
          {filtered.slice((page-1)*PAGE_SIZE, page*PAGE_SIZE).map(p=><Card key={p.sku} product={p} user={user}/>)}
          {!isFiltering&&filtered.length===products.length&&products.length===0&&(
            <div style={{textAlign:"center",padding:"60px 0"}}>
              <div style={{fontSize:40,color:"var(--border2)"}}>▣</div>
              <p style={{color:"var(--text5)",fontSize:11,letterSpacing:2,marginTop:12}}>NENHUM PRODUTO CADASTRADO</p>
            </div>
          )}
          {isFiltering&&filtered.length===0&&(
            <div style={{textAlign:"center",padding:"60px 0"}}>
              <div style={{fontSize:32,color:"var(--border2)"}}>◎</div>
              <p style={{color:"var(--text5)",fontSize:11,letterSpacing:2,marginTop:12}}>NENHUM RESULTADO</p>
              <button onClick={()=>{setActiveFilter("all");setQuery("");}}
                style={{marginTop:16,background:"none",border:"1px solid var(--border2)",color:"var(--text4)",padding:"7px 16px",fontSize:9,letterSpacing:2,cursor:"pointer",borderRadius:2,fontFamily:"'Courier New',monospace"}}>
                LIMPAR FILTROS
              </button>
            </div>
          )}
        </div>

        {filtered.length>PAGE_SIZE&&(
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginTop:20,paddingTop:16,borderTop:"1px solid var(--border)"}}>
            <button onClick={()=>setPage(p=>Math.max(1,p-1))} disabled={page===1}
              style={{background:"none",border:"1px solid var(--border2)",color:page===1?"var(--text5)":"var(--text3)",padding:"7px 16px",fontSize:9,letterSpacing:2,cursor:page===1?"default":"pointer",borderRadius:2,fontFamily:"'Courier New',monospace"}}>
              ANTERIOR
            </button>
            <span style={{fontSize:9,letterSpacing:2,color:"var(--text4)",fontFamily:"'Courier New',monospace"}}>
              {page} / {Math.ceil(filtered.length/PAGE_SIZE)}
            </span>
            <button onClick={()=>setPage(p=>Math.min(Math.ceil(filtered.length/PAGE_SIZE),p+1))} disabled={page>=Math.ceil(filtered.length/PAGE_SIZE)}
              style={{background:"none",border:"1px solid var(--border2)",color:page>=Math.ceil(filtered.length/PAGE_SIZE)?"var(--text5)":"var(--text3)",padding:"7px 16px",fontSize:9,letterSpacing:2,cursor:page>=Math.ceil(filtered.length/PAGE_SIZE)?"default":"pointer",borderRadius:2,fontFamily:"'Courier New',monospace"}}>
              PRÓXIMO
            </button>
          </div>
        )}
      </div>
      {showNew&&<NewProductModal
          user={user}
          onClose={()=>setShowNew(false)}
          onSave={addProduct}
          onSaveLote={addLote}
          onMovimento={mv=>{
            setProducts(prev=>prev.map(p=>{
              if(p.sku!==mv.sku)return p;
              const key=LOC_KEY[mv.location];
              const next={...p};
              if(key)next[key]=Math.max(0,(p[key]||0)+mv.qty);
              next.movements=[{type:mv.type,location:mv.location,qty:mv.qty,note:mv.note,operator:mv.operator,date:mv.date},...p.movements];
              return next;
            }));
          }}
          existingSKUs={products.map(p=>p.sku)}
          nextSkuFn={(empresaNome)=>nextNewSku(products,empresaNome)}
          produtos={products}
        />}
      </div>}
    </div>
  );
}

export default StockModule